import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import filterDetailsLotsPaid from '@/views/private/finance/expenses/travelexpensezpag/components/Tabs/LotsPaid/components/DetailsPaidLots/FilterDetailsPaidLot'
import Tools from '@/components/tools/Tools.js'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin.js'
import { derivaConsulta } from '@/views/private/finance/expenses/travelexpensezpag/rolesEscritaViagem'
const name = 'DetailsPaidLots'

export default {
  name,
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    AutocompleteZ,
    HeadDetailsGama,
    filterDetailsLotsPaid
  },

  props: { },

  updated () { },

  data () {
    return {
      PedidoGerado: false,
      pedido: null,
      funcPedido: null,
      loteid: null,
      ArrayLotePagosDetalhes: [],
      dataSearch: {},
      LotesEmployee: [],
      modalDetalhes: {},
      funcionarioIdDetalhes: null,
      dataInicio: null,
      dataFinal: null,
      SomaDespesa: 0,
      SomaDespesaLote: 0,
      LotesPagosDetalhes: [],
      infoFunc: {}
    }
  },
  mounted () {
    this.onLoad()
    // NAO chamar GetEmpresa() aqui: o metodo nao existe neste componente nem nos mixins
    // (ZC-41). Ele mora no LotsPaid.js e no details.vue do trevelexpenseemployee, que
    // tem `local` no data e mostram a localidade -- aqui nao ha consumidor nenhum.
  },

  computed: {
    // Read-only quando vier da tela de consulta (LotsPaid passa consulta=1 na query).
    // Zera o gerar pedido; o download de comprovantes continua, e leitura.
    //
    // `consulta=1` nao pode ser a unica fonte -- e query string. Ver rolesEscritaViagem.js.
    isConsulta () {
      return derivaConsulta(this.$route.query, this.hasRole)
    }
  },

  methods: {
    onLoad () {
      let param = new URLSearchParams(window.location.search)
      this.loteid = param.get('lote')
      this.getDetailsbyIds(this.loteid)
    },
    async getDetailsbyIds (loteid) {
      loading.push()
      this.dataSearch.EmpresaID = this.CompanySelected
      TravelExpenseRepository.GetLotesPagosByLoteDetalhes(loteid, this.$refs.tableGridLotePagoDetalhes.pagingLimit, this.$refs.tableGridLotePagoDetalhes.pagingIndex, this.dataSearch)
        .then((Response) => {
          loading.pop()
          this.$refs.tableGridLotePagoDetalhes.LoadAllByData(Response)
          this.ArrayLotePagosDetalhes = Response.data.data
          this.LotesPagosDetalhes = this.ArrayLotePagosDetalhes
        })
        .catch((Error) => {
          loading.pop()
          toast.error('error!')
        })
    },
    search (data) {
      this.dataSearch = data
      this.onLoad()
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    formataData (value) {
      if (value !== 'N/D') {
        var data = new Date(value)
        var dia = data.getDate()
        var mes = data.getMonth() + 1
        var ano = data.getFullYear()
        var dataFormatada = dia.toString().padStart(2, '0') + '/' + mes.toString().padStart(2, '0') + '/' + ano
        return dataFormatada
      } else {
        return 'N/D'
      }
    },
    ModalPopup (event) {
      if (event !== undefined && event != null) {
        this.infoFunc = event
      }
      this.loteid = this.infoFunc.id
      this.funcionarioIdDetalhes = this.infoFunc.funcionarioId
      this.$refs['popupExpense'].show()
      this.modalInfo(this.infoFunc)
    },
    modalInfo (event) {
      if (event !== undefined && event != null) {
        this.infoFunc = event
      }
      TravelExpenseRepository.GetExpensesModalByLotes(this.infoFunc.id, this.infoFunc.funcionarioId, this.CompanySelected)
        .then((Response) => {
          this.loteid = this.infoFunc.id
          this.funcionarioIdDetalhes = this.infoFunc.funcionarioId
          this.getLotes()
          this.modalDetalhes = Response.data[0]
        })
    },
    getLotes () {
      TravelExpenseRepository.GetExpensesByLotes(this.loteid, this.funcionarioIdDetalhes, this.CompanySelected, this.$refs.tableGridLotePagoDetalhesViagemModal.pagingLimit, this.$refs.tableGridLotePagoDetalhesViagemModal.pagingIndex)
        .then((Response) => {
          this.loteid = null
          this.funcionarioIdDetalhes = null
          this.$refs.tableGridLotePagoDetalhesViagemModal.LoadAllByData(Response)
          this.LotesEmployee = Response.data.data
        })
    },
    showModalPedido (loteId) {
      this.loteId = loteId.id
      this.funcPedido = loteId.funcionarioId
      this.PedidoGerado = false
      this.$refs['ModalGerarPedido'].show()
    },
    cancelPedido () {
      this.loteId = null
      this.$refs['ModalGerarPedido'].hide()
    },
    onExportAllImages () {
      loading.push()
      const lote = this.modalDetalhes && this.modalDetalhes.lote ? this.modalDetalhes.lote : 'sem-numero'
      const payload = {loteId: this.infoFunc.id, funcionarioId: this.infoFunc.funcionarioId, empresaId: this.CompanySelected}
      TravelExpenseRepository.GerarPDFComprovantes(payload)
        .then((Response) => {
          const fileURL = window.URL.createObjectURL(new Blob([Response.data], {
            type: 'application/pdf'
          }))
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute('download', `comprovantes-viagem-lote-${lote}.pdf`)
          document.body.appendChild(fileLink)
          fileLink.click()
          fileLink.remove()
          loading.close()
        })
        .catch((Error) => {
          toast.error('Nenhuma imagem encontrada para gerar o PDF.')
          loading.close()
        })
    },
    showModalPedidoGerado () {
      loading.push()
      TravelExpenseRepository.GerarPedido({LoteId: this.loteId, FuncionarioId: this.funcPedido, EmpresaId: this.CompanySelected})
        .then((Response) => {
          loading.close()
          this.pedido = Response.data
          this.getDetailsbyIds(this.loteid)
          this.PedidoGerado = true
        })
        .catch((Error) => {
          toast.error('Erro ao gerar pedido!')
          loading.close()
          this.$refs['ModalGerarPedido'].hide()
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/travelexpensezpag/components/Tabs/LotsPaid/components/DetailsPaidLots/DetailsPaidLots.js